import { getChildOrgIdsFromToken } from 'src/utils/jwtTokenUtils'

export const HR_PROFILE_PERMISSION = 'hr_portal:hr_profile:use'
export const ADMIN_VIEW_PERMISSIONS = 'adminui:ui:login'
export const AUTH_VIEW_PERMISSIONS = 'adminui:ui:auth'

export const CEGEKA_ORGANIZATION_ID = '656'

export function isAllowed(context, permission) {
    if (!context?.permissions) {
        return false
    }

    const { permissions } = context
    const invert = permission.startsWith('!')
    if (invert) {
        return !permissions.includes(permission.substring(1))
    }
    return permissions.includes(permission)
}

export function isGlobalAdmin(context) {
    return context?.data?.is_global_admin
}

export function isAnyAllowed(context, permissions) {
    return permissions.some(permission => isAllowed(context, permission))
}

export function isAllAllowed(context, permissions) {
    return permissions.every(permission => isAllowed(context, permission))
}

export function getCurrentOrganizationId(context) {
    if (context?.impersonatedOrganization) {
        return (
            context.impersonatedOrganization.organization_id ??
            context.impersonatedOrganization.value
        )
    }
    return context?.data?.organization_id
}

export function getGlobalSubsidiary(userData, subsidiaryData) {
    return subsidiaryData.currentGlobalSubsidiary
        ? [subsidiaryData.currentGlobalSubsidiary.id]
        : [getCurrentOrganizationId(userData)]
}

export function isCegekaEmployee(context) {
    return getCurrentOrganizationId(context) === CEGEKA_ORGANIZATION_ID
}

export function hasSubtenants(context) {
    return getChildOrgIdsFromToken(context.authToken)?.length > 0
}

export function getSubtenants(context) {
    return getChildOrgIdsFromToken(context.authToken)
}

export function hasDebugMenu(context) {
    return (
        window?.localStorage?.getItem('__horizon_debug__') &&
        isGlobalAdmin(context) &&
        isCegekaEmployee(context)
    )
}

export function getCompanyID(context) {
    return context?.data?.company_id
}
